// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC8E8cQ1Xd7iqcgq9_ljliNaCiiPBkMMsc",
    authDomain: "jitsweb-c0fa7.firebaseapp.com",
    databaseURL: "https://jitsweb-c0fa7.firebaseio.com",
    projectId: "jitsweb-c0fa7",
    storageBucket: "jitsweb-c0fa7.appspot.com",
    messagingSenderId: "323478249605"
  },
  algolia: {
    appId: 'APP_ID',
    apiKey: 'SEARCH_ONLY_KEY',
    indexName: 'getstarted_actors',
    urlSync: false
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts